import { addDays, format, parseISO } from 'date-fns';
import React from 'react';
export const columns = [
  {
    name: <span title="Funcionalidade">Funcionalidade</span>,
    selector: (row) => row.description,
    width: '240px',
  },
  {
    name: <span title="Quantidade">Quantidade</span>,
    selector: (row) => row.count,
  },
  {
    name: <span title="Adicionado em">Adicionado em</span>,
    selector: (row) =>
      row.createdAt ? format(parseISO(row.createdAt), 'dd/MM/yyyy') : '',
    width: '150px',
  },
  {
    name: <span title="Origem">Origem</span>,
    selector: (row) => row?.origin || '-',
  },
  {
    name: <span title="Válido até">Válido até</span>,
    selector: (row) =>
      row.validUntil ? format(parseISO(row.validUntil), 'dd/MM/yyyy') : '',
  },
  {
    name: <span title="Motivo da liberação">Motivo da liberação</span>,
    selector: (row) => row?.releaseReason || 'Não informado',
    width: '270px',
  },
  {
    name: <span title="Nome do admin">Liberado por</span>,
    selector: (row) => row?.releasedBy || '-',
    width: '250px',
  },
  {
    name: <span title="Final do cartão">Final do cartão</span>,
    selector: (row) => row?.cardLastFourDigits || '-',
    width: '140px',
  },
  {
    name: <span title="Valor pago">Valor pago</span>,
    selector: (row) => row?.paidAmount || 0,
  },
  {
    name: 'Id da transação',
    selector: (row) => row?.transactionId || '-',
  },
];

export const ACTIVE_TABS = {
  BILHETAGEM: 'bilhetagem',
  OUTROS: 'outros',
};

export const BENEFITS_TABS_CONFIG = {
  [ACTIVE_TABS.BILHETAGEM]: {
    path: '/subscription/benefits',
    errorMessage:
      'Ocorreu um erro ao carregar os benefícios de calculadoras e consultas.',
  },
  [ACTIVE_TABS.OUTROS]: {
    path: '/subscription/benefits/legacy',
    errorMessage: 'Ocorreu um erro ao carregar os outros benefícios.',
  },
};
export const DATE_INITIAL = format(addDays(new Date(), 3), 'yyyy-MM-dd');
// tone: cor do JdsTag (neutral | brand | success | error | info | warning).
export const JUSZAP_STATUS_MAP = {
  STARTED: {
    label: 'Iniciado',
    tone: 'warning',
  },
  WAITING_FOR_SETTINGS: {
    label: 'Aguardando configuração',
    tone: 'info',
  },
  COMPLETED: {
    label: 'Completo',
    tone: 'success',
  },
  UPDATE_REQUIRED: {
    label: 'Atualização necessária',
    tone: 'error',
  },
  CANCELLED: {
    label: 'Cancelado',
    tone: 'neutral',
  },
};

export const JUSMAIL_STATUS_MAP = {
  CREATED: {
    label: 'Criado',
    tone: 'warning',
  },
  ORDERED: {
    label: 'Solicitado',
    tone: 'warning',
  },
  ACCEPTED: {
    label: 'Aceito',
    tone: 'info',
  },
  REGISTERED: {
    label: 'Registrado',
    tone: 'info',
  },
  VERIFICATION_PENDING: {
    label: 'Verificação pendente',
    tone: 'warning',
  },
  VERIFICATION_FAILED: {
    label: 'Verificação falhou',
    tone: 'error',
  },
  VERIFIED: {
    label: 'Verificado',
    tone: 'info',
  },
  SAML_PENDING: {
    label: 'SAML pendente',
    tone: 'warning',
  },
  READY: {
    label: 'Pronto',
    tone: 'success',
  },
  CANCELLED: {
    label: 'Cancelado',
    tone: 'neutral',
  },
  RENEWING: {
    label: 'Renovando',
    tone: 'info',
  },
  EXPIRED: {
    label: 'Expirado',
    tone: 'error',
  },
  DISABLED: {
    label: 'Desativado',
    tone: 'neutral',
  },
};

// JusCont — status de PAGAMENTO da contratação (juspage-backend: GET /api/juscont/status)
export const JUSCONT_STATUS_MAP = {
  WAITING_PAYMENT: {
    label: 'Aguardando pagamento',
    tone: 'warning',
  },
  PAYMENT_ERROR: {
    label: 'Erro no pagamento',
    tone: 'error',
  },
  PAID: {
    label: 'Pago',
    tone: 'success',
  },
  CANCELLED: {
    label: 'Cancelado',
    tone: 'neutral',
  },
};

export const JUSCONT_PLAN_LABELS = {
  JUSCONT_BASICO: 'Básico',
  JUSCONT_PROFESSIONAL: 'Professional',
  JUSCONT_PREMIUM: 'Premium',
};

export const JUSCONT_ORIGIN_LABELS = {
  ADDON: 'Addon',
  PLAN: 'Incluso no plano',
};

export const JUSCONT_BILLING_CYCLE_LABELS = {
  MONTHLY: 'Mensal',
  ANNUAL: 'Anual',
};
